export default {"src":"/_next/static/media/ellipsis.2158470c.svg","height":512,"width":448,"blurWidth":0,"blurHeight":0};